










import Vue from 'vue';

export default Vue.extend({
  name: 'NewButton',
  props: {
    to: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    icon: {
      type: String,
      default: 'ni ni-bag-17',
    },
  },
});
